import { Component, ViewChild, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppComponentBase } from '@shared/common/app-component-base';
import { IItem } from '../../interfaces/item.interface';
import { DialogResult } from '../mazars-dialog/dialog-result';
import { MazarsDialogComponent } from '../mazars-dialog/mazars-dialog.component';
import { Acceptor } from '../mazars-dialog/acceptor';
import { IAssignableUserDto } from '@shared/service-proxies/common-interfaces';

@Component({
    selector: 'app-mazars-assignable-user-select-edit-modal',
    templateUrl: './mazars-assignable-user-select-edit-modal.component.html',
})
export class MazarsAssignableUserSelectEditModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('editModal', { static: true }) modal: MazarsDialogComponent;
    @Input('uid') uid: string;

    form: FormGroup;
    assignableUsers: IItem<number>[];

    constructor(injector: Injector, private fb: FormBuilder) {
        super(injector);
    }

    ngOnInit(): void {
        this.createForm();
    }

    show(assignedUserId: number, assignableUsers: IAssignableUserDto[]): DialogResult {
        this.assignableUsers = assignableUsers.map((u) => <IItem<number>>{ id: u.id, text: u.fullName, source: u });
        this.form.reset();

        if (this.assignableUsers.find((s) => s.id === assignedUserId) != null) {
            this.form.setValue({
                assignedUserId: assignedUserId,
            });
        }

        return this.modal.show();
    }

    beforeSubmit(acceptor: Acceptor): void {
        let result = this.form.value.assignedUserId;
        acceptor.accept(result);
    }

    private createForm(): void {
        this.form = this.fb.group({
            assignedUserId: [null],
        });
    }
}
